import React from "react";
import { Box, useColorMode } from "@chakra-ui/react";
import { useDispatch, useSelector } from "react-redux";
import { getLoggedInUser } from "@root/store/selectors/entities";
import { LANGUAGE, APP_THEME } from "@root/constants";
import { changeAppLanguage } from "@root/utils/change-language";
import { updateLanguage } from "@root/store/slices/features";
import { userProfile } from "@root/store/thunks/userProfile";
import { CircularEnDark } from "@root/assets/icons/CircularEnDark";
import { CircularEnglishIcon } from "@root/assets/icons/circularEnLangIcon";
import { CircularKoraenIcon } from "@root/assets/icons/circularKoLangIcon";

export const LanguageSwitcher: React.FC = () => {
  const dispatch = useDispatch();
  const { colorMode } = useColorMode();
  const user: any = useSelector(getLoggedInUser);

  const currentLanguage =
    user?.language ||
    localStorage?.getItem("i18nextLng")?.toUpperCase() ||
    LANGUAGE.ENGLISH;

  const handleLanguageToggle = () => {
    const newLanguage =
      currentLanguage === LANGUAGE.ENGLISH ? LANGUAGE.KOREAN : LANGUAGE.ENGLISH;

    changeAppLanguage(newLanguage);
    dispatch(updateLanguage(newLanguage));

    if (user) {
      const payload = { preferred_language: newLanguage?.toLowerCase() };
      dispatch(
        userProfile({
          payload,
          disableAlert: true,
          onSuccess: () => {},
          onError: (error: any) =>
            console.error("Failed to update profile:", error),
        })
      );
    }
  };

  return (
    <Box cursor="pointer" onClick={handleLanguageToggle}>
      {currentLanguage === LANGUAGE.ENGLISH ? (
        colorMode === APP_THEME.DARK ? (
          <CircularEnDark />
        ) : (
          <CircularEnglishIcon />
        )
      ) : (
        <CircularKoraenIcon />
      )}
    </Box>
  );
};
